import { put, call } from 'redux-saga/effects';

import { clientBasicInfo,clientFullList,clientCategoryList,clientList,clientQuickAdd,clientActiveDeactive, clientEdit,clientCompanyInfoAdd,clientPrmryConctAdd,clientCompanyInfoUpdate,clientPrimaryContactUpdate,clientContactList,clientContactAdd,clientRateCardList, clientRateCardUpdate, clientCsvImport, clientCsvQuickFileImport,  clientContactCsvImport, clientGetCrewChiefBonus, clientUpdateCrewChiefBonus,clientContactDelete , clientListForCategories, clientDepartmentsByClientId} from '../services/clientService';


import * as types from '../actions';


export function* clientListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientList, payload);
    yield put({ type: types.CLIENT_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientQuickAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientQuickAdd, payload);
    yield put({ type: types.CLIENT_QUICK_ADD_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_QUICK_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientEdit, payload);
    yield put({ type: types.CLIENT_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCompanyInfoAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCompanyInfoAdd, payload);
    yield put({ type: types.CLIENT_CMPNY_INFO_ADD_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CMPNY_INFO_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientPrmryConctAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientPrmryConctAdd, payload);
    yield put({ type: types.CLIENT_PRMRY_CNCT_ADD_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_PRMRY_CNCT_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCompanyInfoUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCompanyInfoUpdate, payload);
    yield put({ type: types.CLIENT_CMPNY_INFO_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CMPNY_INFO_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientPrmryConctUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientPrimaryContactUpdate, payload);
    yield put({ type: types.CLIENT_PRMRY_CNCT_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_PRMRY_CNCT_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientActiveDeactiveSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientActiveDeactive, payload);
    yield put({ type: types.CLIENT_ACTIVE_DEACTIVE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_ACTIVE_DEACTIVE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


export function* clientContactListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientContactList, payload);
    yield put({ type: types.CLIENT_CONTACT_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CONTACT_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientContactAddSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientContactAdd, payload);
    yield put({ type: types.CLIENT_CONTACT_ADD_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_CONTACT_ADD_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientRateCardListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientRateCardList, payload);
    yield put({ type: types.CLIENT_RATE_CARD_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_RATE_CARD_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
} 

export function* clientRateCardUpdateSaga(payload) {  
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientRateCardUpdate, payload);
    yield put({ type: types.CLIENT_RATE_CARD_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.CLIENT_RATE_CARD_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCsvImportSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCsvImport, payload);
    yield put({ type: types.CLIENT_IMPORT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_IMPORT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientCsvImportQuickFileSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCsvQuickFileImport, payload);
    yield put({ type: types.CLIENT_IMPORT_QUICK_FILE_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_IMPORT_QUICK_FILE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientContactCsvImportSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientContactCsvImport, payload);
    yield put({ type: types.CLIENT_CONTACT_IMPORT_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_CONTACT_IMPORT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}  

export function* clientGetCrewChiefBonusSaga(payload) { 
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientGetCrewChiefBonus, payload);
    yield put({ type: types.CLIENT_GET_CREW_CHIEF_BONUS_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_GET_CREW_CHIEF_BONUS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}  

export function* clientUpdateCrewChiefBonusSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientUpdateCrewChiefBonus, payload);
    yield put({ type: types.CLIENT_UPDATE_CREW_CHIEF_BONUS_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_UPDATE_CREW_CHIEF_BONUS_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}   

export function* clientContactDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientContactDelete, payload);
    yield put({ type: types.CLIENT_CONTACT_DELETE_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_CONTACT_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* profileClientCategoryListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientCategoryList, payload);
    yield put({ type: types.PROFILE_CLIENT_CATEGORY_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.PROFILE_CLIENT_CATEGORY_LIST_SUCCESS, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientListForCategoriesSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientListForCategories, payload);
    yield put({ type: types.CLIENT_LIST_FOR_CATEGORIES_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_LIST_FOR_CATEGORIES_SUCCESS, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}
export function* clientFullListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientFullList, payload);
    yield put({ type: types.CLIENT_FULL_LIST_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_FULL_LIST_SUCCESS, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientBasicInfoSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientBasicInfo, payload);
    yield put({ type: types.CLIENT_COMPANY_BASIC_INFO_SUCCESS, response })
    
  } catch(error) {
    yield put({ type: types.CLIENT_COMPANY_BASIC_INFO_SUCCESS, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* clientDepartmentsByClientIdSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(clientDepartmentsByClientId, payload);
    yield put({ type: types.CLIENT_DEPARTMENTS_LIST_SUCCESS, response }); 
  } catch(error) {
    yield put({ type: types.CLIENT_DEPARTMENTS_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


